/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button, CircularProgress, Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFamilies, navigationButtonStyle } from '../common/common';
import { actionCreators } from '../store/UploadDownloads';
import DropDownWithCheckBox from './DropDownWithCheckBox';
import './styles.css';
interface Props {
    next: any
    isEdit?: boolean
    UpdateSelectedFamilies: Function
    selectedFamilies?: any
    UpdateSelectedProductNames: Function
    selectedProductNames?: any
    UpdateSelectedProductModels: Function
    selectedProductModels?: any
    selectedPdf?: any
    classes?: any,
    isDetailLoadingOnDownloadName: boolean
    UpdateUploadFamilies: Function
    uploadDetails: any
    FilterUploadNames: Function
    FilterUploadModels: Function
    selectedNameColors: any,
    selectedModelColors: any
}
const styles = () => ({
    input: {
        height: 35,
        width: 210
    },
    navigationButton: navigationButtonStyle
});

class ClassificationSelection extends React.Component<Props, {}>{
    state = {
    };
    async componentDidMount() {
        const family = await getFamilies();
        this.props.UpdateUploadFamilies(family.data);
    }
    SelectFamily = async (selectedFamilies: any) => {
        if (this.props.uploadDetails.families !== undefined && selectedFamilies !== undefined) {
            this.props.UpdateSelectedFamilies(selectedFamilies);
            await this.props.FilterUploadNames(this.props.uploadDetails.families, selectedFamilies);
        }
    };
    SelectProductName = async (selectedProductNames: any) => {
        if (this.props.uploadDetails.productNames !== undefined && selectedProductNames !== undefined) {
            this.props.UpdateSelectedProductNames(selectedProductNames);
            await this.props.FilterUploadModels(this.props.uploadDetails.productNames, selectedProductNames);
        }
    };
    selectProductModel = (selectedProductModels: any) => {
        this.props.UpdateSelectedProductModels(selectedProductModels);
    };
    render() {
        const { classes } = this.props;
        const hasExistingDownload = this.props.isEdit || this.props.selectedPdf !== undefined;
        let isDisabled = true, isNextDisabled = true, title = '';
        if (!hasExistingDownload) {
            isDisabled = true;
            title = '1. Upload the Downloads';
        }
        else {
            if (this.props.selectedProductModels !== undefined && this.props.selectedProductModels.length) {
                isNextDisabled = false;
            }
            isDisabled = false;
            title = '2. Assign the Downloads';
        }
        return (
            <Grid className="classificationGrid" style={this.props.isDetailLoadingOnDownloadName ? { width: '45%' } : {}}>
                {this.props.uploadDetails.families &&
                    (
                        this.props.isDetailLoadingOnDownloadName ?
                            <div className="uploadClassificationInitial">
                                <CircularProgress color="secondary" />
                            </div>
                            :
                            <Grid style={{ height: '95%' }}>
                                <Grid style={{ height: '5%', textAlign: 'center', fontWeight: 'bold' }}>{title}</Grid>
                                <Grid className="classificationGridContents">
                                    <DropDownWithCheckBox title={'Product Family'} listValues={this.props.uploadDetails.families}
                                        UpdateSelectedValues={this.SelectFamily} disabled={isDisabled} isSelectOnlyOne={false} selectedValues={this.props.selectedFamilies} />
                                </Grid>
                                <Grid className="classificationGridContents">
                                    <DropDownWithCheckBox title={'Product Name'} listValues={this.props.uploadDetails.productNames}
                                        UpdateSelectedValues={this.SelectProductName} disabled={isDisabled} selectedValues={this.props.selectedProductNames}
                                        selectedColors={this.props.selectedNameColors} isSelectOnlyOne={false} />
                                </Grid>
                                <Grid className="classificationGridContents">
                                    <DropDownWithCheckBox title={'Product Model'} listValues={this.props.uploadDetails.productModels}
                                        UpdateSelectedValues={this.selectProductModel} disabled={isDisabled} selectedValues={this.props.selectedProductModels}
                                        selectedColors={this.props.selectedModelColors} isSelectOnlyOne={false} />
                                </Grid>
                            </Grid>
                    )
                }
                <Grid container justifyContent="flex-end">
                    <Button className={classes.navigationButton} onClick={this.props.next} disabled={isNextDisabled}>Next</Button>
                </Grid>
            </Grid>
        );
    }
}
const mapStateToProps = (state: any) => ({
    selectedFamilies: state.uploadDownloads.selectedFamilies,
    selectedProductNames: state.uploadDownloads.selectedProductNames,
    selectedProductModels: state.uploadDownloads.selectedProductModels,
    selectedPdf: state.uploadDownloads.selectedPdf,
    isDetailLoadingOnDownloadName: state.uploadDownloads.isDetailLoadingOnDownloadName,
    uploadDetails: state.uploadDownloads.uploadDetails,
    selectedNameColors: state.uploadDownloads.selectedNameColors,
    selectedModelColors: state.uploadDownloads.selectedModelColors
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchtoProps
)
    (withStyles(styles)(ClassificationSelection));
